import http from "../../../util/http"
const prefix = "/share-foreign"
export default {
  /**
   * 护照注销管理 保存函件内容
   *
   */
  saveDestoryLetter(data){
    return http.post(prefix+"/offline/destroyPassport/saveLetter",data)
  },
  /**
   *获取企业申请注销护照列表
   *
   * @param {{leaderName: String,pageNo: Number, pageSize: Number}} data
   * @returns
   */
  getCompanyList(data) {
    return http.post(prefix + "/offline/destroyPassport/getEntPage", data)
  },
  /**
   *获取集团申请注销护照列表
   *
   * @param {{leaderName: String,pageNo: Number, pageSize: Number}} data
   * @returns
   */
  getCorporationList(data) {
    return http.post(prefix + "/offline/destroyPassport/getPage", data)
  },
  /**
   *新增注销
   *
   * @param {{destroyId: String,companyName: String,leaderName: String,num:Number}} data
   * @returns
   */
  addCancellation(data){
    return http.post(prefix+"/offline/destroyPassport/desPassportAddOrEdit",data)
  },
  /**
   *删除注销
   *
   * @param {{destroyId: String}} data
   */
  delCancellation(data){
    return http.post(prefix+"/offline/destroyPassport/delPassport",data)
  },
  /**
   *详情
   *
   * @param {{destroyId: String}} data
   * @returns
   */
  detail(data){
    return http.post(prefix+"/offline/destroyPassport/details",data)
  },
  /**
   *护照注销 生成日志
   *
   * @param {{id: String}} data
   * @returns
   */
  addGenerateLog(data){
    return http.post(prefix+"/offline/renewalPassport/addGenerateLog",data)
  },
  /**
   *提交
   *
   * @param {{destroyId: String}} data
   * @returns
   */
  submit(data){
    return http.post(prefix+"/offline/destroyPassport/submit",data)
  },
  /**
   *审批
   *
   * @param {{destroyId: String}} data
   * @returns
   */
  approval(data){
    return http.post(prefix+"/offline/destroyPassport/submitApproval",data)
  },
  reject(data){
    return http.post(prefix+"/offline/destroyPassport/fallback",data)
  },
  finish(data){
    return http.post(prefix+"/offline/destroyPassport/complete",data)
  },
  /**
   *添加人员
   *
   * @param {*} data
   * @returns
   */
  addPerson(data){
    return http.post(prefix+"/offline/destroyPassportUser/desPassportUserAddOrEdit",data)
  },
  delPerson(data){
    return http.post(prefix+"/offline/destroyPassportUser/delPassportUser",data)
  },
  /**
   *获取人员列表
   *
   * @param {{name: String}} data
   * @returns
   */
  personList(data){
    return http.post(prefix+"/visa/personInfo/getPersonInfosPage",data)
  },
   /**
   *提交任务
   *
   * @param {{destroyId: String, agree: String, opinion: String}} data
   * @returns
   */
  submitTask(data){
    return http.post(prefix+"/offline/destroyPassport/submitTask",data)
  },

  /**
   * 修改开函时间
   *
   */
  editOpenTime(data){
    return http.post(prefix+"/offline/destroyPassport/updateOpenTime",data)
  },
  /**
   * 公函管理操作日志或者审核日志
   *
   */
  getExamineLogs(data){
    return http.post(prefix+"/offline/passportOperate/getExamineLogs",data)
  },

  /**
   * 操作日志
   *
   */
    getOperateLogs(data){
      return http.post(prefix+"/offline/passportOperate/getOperateLogs",data)
    },
    /**
     * 指纹提交操作日志
     *
     */
    getFingerUploadLog(data){
      return http.post(prefix+"/visa/personInfo/getFingerUploadLog",data)
    },

   /**
   * 撤回
   *
   */
   withdraw(data){
    return http.post(prefix+"/offline/destroyPassport/withdraw",data)
  }
}
